import React, { useState } from 'react';
import useCurrentUser from '~/hooks/useCurrentUser';
import ConfirmActionModal from '../../components/ConfirmActionModal';
import BasePopover from '../../components/BasePopover';
import type { ActionModalProps } from '../../constants';
import useTrackEvent from '~/hooks/useTrackEvent';

const text = {
  title: 'Contacten exporteren',
  confirm: 'Bevestigen',
  popoverDescription:
    'Exporteer de geselecteerde contacten naar een CSV bestand. Het bestand wordt verzonden naar ',
};

export type Props = {} & ActionModalProps;

const SendCSV: React.FCC<Props> = ({
  onCancel,
  onComplete,
  selectedContactAmount,
  ...rest
}) => {
  const [showModal, setShowModal] = useState(false);
  const hideModal = () => setShowModal(false);
  const trackEvent = useTrackEvent();
  const email = useCurrentUser().email;

  return (
    <>
      {showModal ? (
        <ConfirmActionModal
          selectedContactAmount={selectedContactAmount}
          actionType="SendCSV"
          actionInput={{
            SendCSV: {
              noOperation: null,
            },
          }}
          onComplete={() => {
            /** ----- TRACKING: contacts_exported ----- */
            trackEvent({
              eventName: 'contacts_exported',
              parameters: {
                contacts_amount: selectedContactAmount,
              },
            });
            hideModal();
            onComplete();
          }}
          onCancel={hideModal}
          {...rest}
        />
      ) : (
        <BasePopover
          title={text.title}
          handleAction={confirm => {
            if (confirm) {
              setShowModal(true);
            } else {
              onCancel();
            }
          }}
          confirmText={text.confirm}
        >
          {text.popoverDescription} <strong>{email}</strong>
        </BasePopover>
      )}
    </>
  );
};

export default SendCSV;
